<template>
    <!-- Background color for a component should be set on this div -->
    <div class="overflow-hidden scroll-scene">
        <component
            :is="getType(data.type)"
            :component="data"
            class="w-full"
            @loaded="$emit('loaded')"
            :key="(data.id || data.type) + '-' + (data.rerenderCount || globalRerenderCount)"
        ></component>
    </div>
</template>

<script>
import Header from './Header.vue';
import Awards from './Awards.vue';
import Facebook from './Facebook.vue';
import Facts from './Facts.vue';
import Gallery from './Gallery.vue';
import Instagram from './Instagram.vue';
import Jobs from './Jobs.vue';
import Linkedin from './Linkedin.vue';
import Locations from './Locations.vue';
import Perks from './Perks.vue';
import Quotes from './Quotes.vue';
import Team from './Team.vue';
import Text from './Text.vue';
import Twitter from './Twitter.vue';
import Values from './Values.vue';
import Video from './Video.vue';
import Footer from './Footer.vue';
import Menu from './Menu.vue';
import { mapState } from 'pinia';
import { useBrandingStore } from '../../state/branding'

export default {
    components: {
        'site-menu': Menu,
        'site-header': Header,
        'awards': Awards,
        'facebook': Facebook,
        'facts': Facts,
        'gallery': Gallery,
        'instagram': Instagram,
        'jobs': Jobs,
        'linkedin': Linkedin,
        'locations': Locations,
        'perks': Perks,
        'quotes': Quotes,
        'team': Team,
        'text-component': Text,
        'twitter': Twitter,
        'values': Values,
        'video-component': Video,
        'site-footer': Footer,
    },
    props: {
        data: {
            type: Object,
            required: true,
        }
    },
    computed: {
        ...mapState(useBrandingStore, ['globalRerenderCount']),
    },
    methods: {
        getType (type) {
            return {
                video: 'video-component',
                text: 'text-component',
                twitter: 'twitter',
                facebook: 'facebook',
                quote: 'quotes',
                facts: 'facts',
                perks: 'perks'
            }[type] || type
        }
    }
}
</script>
